
import stationDataTrainingComponent from "@/components/stations/StationDataTraining.component.vue";
import { defineComponent, reactive, ref } from "vue";
import {} from "@/types/trainingData.type";
import { getvisualizeTrainingData, downloadTrainingData } from "@/service/trainingData.service";
import { getAllContainer } from "@/service/container.service";
import { TrainingData } from "@/types/trainingData.type";
import { SamplingPoint } from "../../types/samplingpoint.type";
import { Parameter } from "@/types/parameter.type";
import { FormInstance, ElForm } from "element-plus";
import { getParameter } from "@/service/parameter.service";
import { Filter } from "@/types/filter.type";
import { downloadFile } from "@/utils/blob.util";
import { Container } from "@/types/container.type";
import { AppError } from "@/types/app.type";

export default defineComponent({
  components: {
    stationDataTrainingComponent,
  },
  //origen
  setup() {
    const ruleFormRef = ref<FormInstance>();
    const originList = [
      {
        value: "CONTROL_ALGAS",
        label: "CONTROL DE ALGAS (SUPERFICIE)",
      },
      {
        value: "SCADA",
        label: "SCADA",
      },
      {
        value: "LABORATORIO",
        label: "LABORATORIO",
      },
      {
        value: "AQUACORP",
        label: "AQUACORP",
      },
      {
        value: "MULTIPARAMETRICA",
        label: "MULTIPARAMÉTRICA",
      },
      {
        value: "DUERO",
        label: "DUERO",
      },
      {
        value: "SONDA_DQO",
        label: "SONDA DQO",
      },

      {
        value: "SCRAPPING",
        label: "SCRAPPING",
      },
      {
        value: "SCRAPPING_SAIH",
        label: "SCRAPPING_SAIH",
      },
      {
        value: "SCRAPPING_AEMET",
        label: "SCRAPPING_AEMET",
      },
      {
        value: "SINTETICO",
        label: "SINTÉTICO",
      },
    ];

    return { originList, ruleFormRef };
  },
  data() {
    return {
      visualize: false as boolean,
      trainingDataForm: {} as TrainingData,
      samplingPoint: undefined as string | undefined,
      selectedSamPoint: {} as SamplingPoint, // selectedSamPoint
      containers: [] as Container[], //- Lista de contenedores del sistema
      containerSelect: {} as Container, //- Lista de contenedores del sistema
      selectedContainer: [] as Container[], //- Lista de contenedores del sistema
      src: ref<{ [name: string]: string }>({}),
      datesWithData: reactive<string[]>([]),
      dateKey: 0,

      form: {
        file: [] as Array<{ name: string; url: string | ArrayBuffer | null | undefined }>,
      },

      samplingpoints: [] as SamplingPoint[],
      parameters: [] as Parameter[],
      disableParameter: true as boolean,
      changesParameterType: true as boolean,
      dataTraining: [] as any,
      filter: {} as Filter,
      rules: {
        container: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        origin: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        startDate: [
          {
            type: "date",
            required: true,
            message: this.$t("error.required"),
            trigger: "change",
          },
        ],
        endDate: [
          {
            type: "date",
            required: true,
            message: this.$t("error.required"),
            trigger: "change",
          },
        ],
      },
    };
  },
  async mounted() {
    this.containers = await getAllContainer();
    let paramsData = await getParameter();
    this.parameters = paramsData.data;
  },
  watch: {
    trainingDataForm: {
      deep: true,
      handler(newForm) {
        const { container, origin, codeParameter } = newForm;
        const isFormComplete = container && origin && (this.changesParameterType || codeParameter);
        if (isFormComplete) {
          //this.getMarkedDates();
        }
      },
    },
  },

  methods: {
    async validate() {
      let valid;
      try {
        valid = await (this.$refs["myForm"] as InstanceType<typeof ElForm>).validate();
      } catch (error) {
        valid = false;
      }
      if (!valid) {
        throw new Error(AppError.FORM_VALIDATION);
      }
    },
    //- seleconamos los parametros del punto de monitorizacion
    async visualizeData() {
      await this.validate();

      //todas
      // Campos comunes
      let baseFilter: {
        fields: { [key: string]: { operator: string; value: any } };
      } = {
        fields: {
          "trainingData.containerId": {
            operator: "equal",
            value: this.trainingDataForm.container.id,
          },
          "trainingData.samplingPointType": {
            operator: this.trainingDataForm.samplingPointType ? "equal" : "is null",
            value: this.trainingDataForm.samplingPointType || "",
          },
          "trainingData.origin": {
            operator: "equal",
            value: this.trainingDataForm.origin,
          },
          "trainingData.dateTime": {
            operator: "between",
            value: [this.trainingDataForm.startDate, this.trainingDataForm.endDate],
          },
        },
      };

      // Añadir campos adicionales según la condición
      if (!this.changesParameterType) {
        baseFilter.fields["trainingData.codeParameter"] = {
          operator: "equal",
          value: this.trainingDataForm.codeParameter,
        };
      }

      this.filter = baseFilter as Filter;
      let trainingData = await getvisualizeTrainingData(
        undefined,
        undefined,
        this.filter,
        undefined
      );
      if (trainingData) {
        this.dataTraining = trainingData;
        this.visualize = true;
      } else {
        this.dataTraining = [];
      }
    },
    async getMarkedDates() {
      let baseFilter: {
        fields: { [key: string]: { operator: string; value: any } };
      } = {
        fields: {
          "trainingData.containerId": {
            operator: "equal",
            value: this.trainingDataForm.container.id,
          },
          "trainingData.samplingPointType": {
            operator: this.trainingDataForm.samplingPointType ? "equal" : "is null",
            value: this.trainingDataForm.samplingPointType || "",
          },
          "trainingData.origin": {
            operator: "equal",
            value: this.trainingDataForm.origin,
          },
        },
      };

      // Añadir campos adicionales según la condición
      if (!this.changesParameterType) {
        baseFilter.fields["trainingData.codeParameter"] = {
          operator: "equal",
          value: this.trainingDataForm.codeParameter,
        };
      }

      this.filter = baseFilter as Filter;

      let trainingData = await getvisualizeTrainingData(
        undefined,
        undefined,
        this.filter,
        undefined
      );
      if (trainingData) {
        this.datesWithData = Array.from(
          new Set(trainingData.data.map((item: any) => new Date(item.dateTime).toDateString()))
        );
        this.dateKey++;
      }
    },
    hasEstimatedData(day: Date) {
      return this.datesWithData.includes(day.toDateString());
    },
    async downoloadData() {
      await this.validate();

      let file = await downloadTrainingData(undefined, undefined, this.filter, undefined);
      downloadFile(file.url, file.fileName);
    },
  },
});
